import React from "react";

import { NAVBAR } from "@config/testIds/navbar";

import { Dropdown } from "@components/Navigation/Dropdown";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { useTranslate } from "@hooks/useTranslate";

import * as VerticalNav from "../VerticalNav";
import { useNavBar } from "../hooks/useNavBar";
import { useLangNav } from "../hooks/useLangNav";

import * as Styled from "./LanguageSelector.styled";

export const LanguageSelector: React.FC = () => {
  const translate = useTranslate("batmaid_pwa_navigation");
  const { language } = useNavBar();
  const { links } = useLangNav();

  const [isDropdownActive, setIsDropdownActive] = React.useState(false);

  return (
    <Styled.Root>
      <Dropdown
        testIds={{
          button: NAVBAR.LANGUAGE_TRIGGER,
          panel: NAVBAR.LANGUAGE_DROPDOWN,
        }}
        eventId="languageDropdown"
        label={language.toUpperCase()}
        position="right"
        distance={14}
        isActive={isDropdownActive}
        setIsActive={setIsDropdownActive}
      >
        <VerticalNav.Nav>
          <VerticalNav.Header
            $style={{
              default: "medium_16",
              smallDesktop: "medium_18",
            }}
          >
            {translate("choose_language")}
          </VerticalNav.Header>

          {links.map(link => (
            <TestWrapper key={link.testId} testId={link.testId}>
              <VerticalNav.Link
                as="a"
                href={link.href}
                onClick={link.clickHandler}
                $style={{
                  default: "medium_16",
                  smallDesktop: "medium_18",
                }}
              >
                <VerticalNav.CodeBlock>{link.code}</VerticalNav.CodeBlock>
                <span>{link.label}</span>
              </VerticalNav.Link>
            </TestWrapper>
          ))}
        </VerticalNav.Nav>
      </Dropdown>
    </Styled.Root>
  );
};
